import React, {useState} from 'react'
import {IconShield, IconShieldFilled, IconUserCircle, IconUserShield} from '@tabler/icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux/slices/authSlice';
import { Avatar, Button, Center, Group, Text, Paper, MediaQuery, Badge } from '@mantine/core';
import { AppDataService } from '../services/AppDataService';
import { useNavigate } from 'react-router-dom';
import SkeletonGroup from './SkeletonGroup';
import { createImageUrl } from '../utils/CommonUtils';

const AuthMenuBar = () => {
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogoutClick = async () => {
    setLoading(true);
    await AppDataService.Logout();
    setLoading(false);
    dispatch(logout());
  }

  const handleLoginClick = () => {
    navigate('/authenticate');
  }

  return (
    <Group>
      {
        authState.isAuthenticated ? (
          <>
            {
              authState.user.isAdmin && (
                <MediaQuery smallerThan='sm' styles={{ display: 'none' }}>
                    <Badge radius='sm' variant='gradient' gradient={{ from: 'grape', to: 'violet' }} size='md' color='violet'>ADMIN</Badge>
                </MediaQuery>
              )
            }
            <MediaQuery smallerThan='sm' styles={{ display: 'none' }}>
              <Paper style={{ cursor: 'pointer' }} radius='xl' bg='#F0F8FF' px={10} pt={3} pb={3}>
                <Group>
                  <Avatar src={createImageUrl(authState.user.profileImage?.imageRaw) || null} radius='xl' size={35} alt={authState.user.firstName} onClick={() => navigate(`/profile`)} />
                  <Text weight={500} size="sm" sx={{ lineHeight: 1 }} mr={3}>{authState.user.firstName} {authState.user.lastName}</Text>
                  <Button compact fz={10} size='xs' radius='lg' color='indigo' onClick={handleLogoutClick}>LOGOUT</Button>
                </Group>
              </Paper>
            </MediaQuery>
            <MediaQuery largerThan='sm' styles={{ display: 'none'}}>
              <Button compact fz={10} size='xs' radius='lg' color='indigo' onClick={handleLogoutClick}>LOGOUT</Button>
            </MediaQuery>
          </>
        ) : authState.loadState === 'loading' ? (
          <SkeletonGroup height={35} width={250} num={1} />
        ) : (
          <Button mt={5} size='xs' radius='xl' color='blue' onClick={handleLoginClick} loading={loading}>Login / Register</Button>
        )
      }
    </Group>
  )
}

export default AuthMenuBar